/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */

export const LogoImgContainer = `
    width: 105px;
    height: 32px;
`;
